import React, { useContext, useState } from "react";
import { Context } from "./index";
import { ReactComponent as DaySvg } from "../../../assets/newProject/day.svg";
import { ReactComponent as NightSvg } from "../../../assets/newProject/night.svg";

const CycleWizard = () => {
  const {
    images,
    cycles,
    setCycles,
    selectedImageName: selectedImageIndex,
    closeOverlay,
  } = useContext(Context);

  const [step, setStep] = useState(1);
  const [type, setType] = useState(undefined);

  const handleCycleClick = (type) => {
    setType(type);
    setStep(2);
  };

  const handleImageClick = (imageName) => {
    const temp = {
      day: type === "day" ? imageName : selectedImageIndex,
      night: type === "night" ? imageName : selectedImageIndex,
    };

    setCycles((curr) => [...(curr || []), temp]);
    closeOverlay();
  };

  const handleCancelClick = () => {
    setType("");
    closeOverlay();
  };

  const handleReturnClick = () => {
    setStep(1);
  };

  const getRender = () => {
    if (step === 1) {
      return (
        <div className="new-project-hotspot-pannellum-daynight-content-type">
          <button
            className="new-project-hotspot-pannellum-daynight-content-type__cancel"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
          <h3 className="new-project-hotspot-pannellum-daynight-content-type__header">
            Select cycle to add
          </h3>
          <div className="new-project-hotspot-pannellum-daynight-content-type-options">
            <div
              className="new-project-hotspot-pannellum-daynight-content-type-options__item"
              onClick={() => handleCycleClick("day")}
            >
              <DaySvg width={28} />
              Day
            </div>
            <div
              className="new-project-hotspot-pannellum-daynight-content-type-options__item"
              onClick={() => handleCycleClick("night")}
            >
              <NightSvg width={28} />
              Night
            </div>
          </div>
          <span className="new-project-hotspot-pannellum-daynight-content-type__sub">
            Current scene will marked as the other option
          </span>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="new-project-hotspot-pannellum-daynight-content-scenes">
          <div className="new-project-hotspot-pannellum-daynight-content-scenes-header">
            <h3 className="new-project-hotspot-pannellum-daynight-content-scenes-header__title">
              {`Select ${type} scene`}
            </h3>
            <button
              className="new-project-hotspot-pannellum-daynight-content-scenes-header__return"
              onClick={handleReturnClick}
            >
              Return
            </button>
          </div>
          <div className="new-project-hotspot-pannellum-daynight-content-scenes-gallery">
            {images.map((image, index) => {
              if (image.name === selectedImageIndex) {
                return <></>;
              }

              if (cycles.find((c) => c.day === index || c.night === index))
                return <></>;

              return (
                <img
                  className="new-project-hotspot-pannellum-daynight-content-scenes-gallery__image"
                  src={URL.createObjectURL(image)}
                  onClick={() => handleImageClick(image.name)}
                />
              );
            })}
          </div>
        </div>
      );
    }

    return <></>;
  };

  return (
    <div className="new-project-hotspot-pannellum-daynight">
      <div className="new-project-hotspot-pannellum-daynight-content">
        {getRender()}
      </div>
    </div>
  );
};

export default CycleWizard;
